import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import Circular from '../components/Circularprogress.jsx';
import Modalopener from '../modal/Modal.jsx';
import Menuname from '../components/Supplymenu2.jsx';
import { Modal } from '@mui/material';
import Modalviewer from '../modal/Modalview.jsx';
import Modaldelete from '../modal/Modaldelete.jsx';
import Modalediter from '../modal/Modaledit.jsx';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
// import { getadmin } from '../redux/admin.jsx';
// import { getfarmer } from '../redux/farmer.jsx';
import { getmechanization } from '../redux/mechanization.jsx';
import { getagent } from '../redux/agent.jsx';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import Progress from '../components/Loader';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import EngineeringIcon from '@mui/icons-material/Engineering';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';

const headCells = [
  {
    id: 'customer',
    numeric: false,
    disablePadding: false,
    label: 'Customer',
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    label: 'Type',
  },
  {
    id: 'agent',
    numeric: false,
    disablePadding: false,
    label: 'Agent',
  },
  {
    id: 'service',
    numeric: true,
    disablePadding: false,
    label: 'Service',
  },
  {
    id: 'date',
    numeric: true,
    disablePadding: false,
    label: 'Date',
  },
  {
    id: 'cost',
    numeric: true,
    disablePadding: false,
    label: 'Cost',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
  }
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="normal">
          No.
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default function AdminMechanization() {
  const dispatch = useDispatch();
  const admin = useSelector((state) => state.admin);
  const farmer = useSelector((state) => state.farmer);
  const mechanization = useSelector((state) => state.mechanization);
  const agents = useSelector((state) => state.agent || []);

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('date');
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [search, setSearch] = React.useState("");
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [typeFilter, setTypeFilter] = React.useState('all');
  const [statusFilter, setStatusFilter] = React.useState('all');
  const [agentFilter, setAgentFilter] = React.useState('all');
  const [Modalvalue, setModalvalue] = React.useState(false);
  const [Modalview, setModalview] = React.useState(false);
  const [Modaldeleter, setModaldeleter] = React.useState(false);
  const [Modaledit, setModaledit] = React.useState(false);
  const [Chosen, setChosen] = React.useState([]);
  const [expenseModalOpen, setExpenseModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [payment, setPayment] = React.useState("none");

  React.useEffect(() => {
    dispatch(getagent());
  }, [dispatch]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const showdata = (event, data) => {
    setModalvalue(true);
    setChosen(data);
  };

  const setoff = () => {
    setModalvalue(false);
    setModaldeleter(false);
    setModaledit(false);
  };

  const setview = () => {
    setModalview(true);
    setModalvalue(false);
  };

  const setdeleter = () => {
    setModaldeleter(true);
  };

  const setedit = () => {
    setModaledit(true);
  };

  const setoffer = () => {
    setModalview(false);
    setModaldeleter(false);
    setModaledit(false);
  };

  // Add a function to get agent name
  const getAgentName = (agentId) => {
    if (!agentId) {
      console.log('No agent ID provided');
      return 'No Agent ID';
    }
    
    // Ensure agents is an array
    const agentsArray = Array.isArray(agents) ? agents : [];
    
    const agent = agentsArray.find(item => item._id === agentId);
    if (!agent) {
      console.log(`Agent not found for ID: ${agentId}`);
      return `Unknown Agent (${agentId})`;
    }
    
    const fullName = `${agent.surname || ''} ${agent.lastname || ''} ${agent.othername || ''}`.trim();
    const displayName = fullName || agent.name || `Agent ${agentId}`;
    console.log(`Found agent: ${displayName} for ID: ${agentId}`);
    return displayName;
  };

  // Filter and sort the data
  const filteredData = React.useMemo(() => {
    let filtered = [...mechanization]; // Create a copy of the array

    // Apply search filter
    if (search) {
      filtered = filtered.filter(item => 
        (item.customer && item.customer.toLowerCase().includes(search.toLowerCase())) ||
        (item.purchase && item.purchase[0]?.product?.toLowerCase().includes(search.toLowerCase())) ||
        (item.operator && item.operator.toLowerCase().includes(search.toLowerCase())) ||
        (getAgentName(item.agent).toLowerCase().includes(search.toLowerCase()))
      );
    }

    // Apply type filter
    if (typeFilter !== 'all') {
      filtered = filtered.filter(item => item.type === typeFilter);
    }

    // Apply status filter
    if (statusFilter !== 'all') {
      filtered = filtered.filter(item => {
        const itemStatus = item.status || 'pending'; // Default to 'pending' if status is undefined
        return itemStatus.toLowerCase() === statusFilter.toLowerCase();
      });
    }

    // Apply agent filter
    if (agentFilter !== 'all') {
      filtered = filtered.filter(item => item.agent === agentFilter);
    }

    // Apply date range filter
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.date);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;
        return (!start || itemDate >= start) && (!end || itemDate <= end);
      });
    }

    // Sort the data
    return filtered.sort((a, b) => {
      let aValue = a[orderBy];
      let bValue = b[orderBy];
      
      // Handle special cases for different field types
      if (orderBy === 'customer') {
        // For customer, get the farmer name
        aValue = farmer.find(item => item._id === aValue)?.farmername || aValue || '';
        bValue = farmer.find(item => item._id === bValue)?.farmername || bValue || '';
      } else if (orderBy === 'agent') {
        // For agent, get the agent name
        aValue = getAgentName(aValue);
        bValue = getAgentName(bValue);
      } else if (orderBy === 'service') {
        // For service, get the product name
        aValue = a.purchase?.[0]?.product || '';
        bValue = b.purchase?.[0]?.product || '';
      } else if (orderBy === 'cost') {
        // For cost, calculate the total cost
        aValue = a.purchase?.[0] ? (parseFloat(a.purchase[0].qty || 0) * parseFloat(a.purchase[0].unitp || 0)) : 0;
        bValue = b.purchase?.[0] ? (parseFloat(b.purchase[0].qty || 0) * parseFloat(b.purchase[0].unitp || 0)) : 0;
      } else if (orderBy === 'status') {
        // For status, ensure we have a string value
        aValue = aValue || 'pending';
        bValue = bValue || 'pending';
      } else if (orderBy === 'date') {
        // For date, convert to Date objects for proper comparison
        aValue = aValue ? new Date(aValue) : new Date(0);
        bValue = bValue ? new Date(bValue) : new Date(0);
      }
      
      // Handle null/undefined values
      if (aValue === null || aValue === undefined) aValue = '';
      if (bValue === null || bValue === undefined) bValue = '';
      
      // Convert to strings for comparison if they're not dates
      if (!(aValue instanceof Date) && !(bValue instanceof Date)) {
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
      }
      
      if (order === 'asc') {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      } else {
        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
      }
    });
  }, [mechanization, search, typeFilter, statusFilter, agentFilter, startDate, endDate, order, orderBy, agents, farmer]);

  const visibleRows = React.useMemo(
    () => filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [filteredData, page, rowsPerPage]
  );

  const handleExpenseModalOpen = () => setExpenseModalOpen(true);
  const handleExpenseModalClose = () => setExpenseModalOpen(false);
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearExpenseForm = () => {
    document.getElementById("type").value = '';
    document.getElementById("amount").value = '';
    document.getElementById("quantity").value = '';
    document.getElementById("unit").value = '';
    document.getElementById("date").value = '';
    document.getElementById("location").value = '';
    document.getElementById("driver").value = '';
    document.getElementById("tractor").value = '';
    document.getElementById("description").value = '';
    document.getElementById("transaction").value = '';
    setPayment("none");
  };

  const addExpense = () => {
    setLoading(true);
    const data = {
      type: document.getElementById("type").value,
      amount: document.getElementById("amount").value,
      quantity: document.getElementById("quantity").value,
      unit: document.getElementById("unit").value,
      date: document.getElementById("date").value,
      location: document.getElementById("location").value,
      driver: document.getElementById("driver").value,
      tractor: document.getElementById("tractor").value,
      description: document.getElementById("description").value,
      transaction: document.getElementById("transaction").value,
      payment: payment,
    };

    const doer = async () => {
      try {
        const res = await axios.post("https://embert.sisrevolution.com/api/mechanization/addexpenses/", {
          data: data,
          id: Chosen.id
        });

        if (res.status === 200) {
          setLoading(false);
          dispatch(getmechanization({ data: res.data }));
          setSnackbarMessage('Expenses submitted successfully!');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          clearExpenseForm();
          handleExpenseModalClose();
        } else {
          setLoading(false);
          setSnackbarMessage('Failed to submit expenses.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setLoading(false);
        setSnackbarMessage('Error submitting expenses.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    };

    doer();
  };

  return (
    <Box sx={{ width: '100%' }}>
      {Modalvalue && (
        <Modalopener
          value={Modalvalue}
          chosen={Chosen}
          product={Chosen.name}
          setfalse={setoff}
          name="Mechanization"
          Menu={
            <Menuname
              name="Mechanization"
              chosen={Chosen}
              value={Modalview}
              view={setview}
              delete={setdeleter}
              edit={setedit}
              product={Chosen.name}
            />
          }
        />
      )}
      {Modalview && (
        <Modalviewer
          name="Mechanization"
          product={Chosen.name}
          chosen={Chosen}
          view={setview}
          setfalser={setoffer}
          value={Modalvalue}
          details={{
            customer: farmer.find(item => item._id === Chosen.customer)?.farmername || Chosen.customer,
            type: Chosen.type || 'No Type',
            agent: getAgentName(Chosen.agent),
            service: Chosen.purchase?.[0]?.product || 'No Product',
            date: Chosen.date || 'No Date',
            cost: Chosen.purchase?.[0] ? 
              (parseFloat(Chosen.purchase[0].qty || 0) * parseFloat(Chosen.purchase[0].unitp || 0)).toFixed(2) 
              : '0.00',
            operator: Chosen.operator || 'No Operator',
            tractorNumber: Chosen.tractornumber || 'No Tractor Number',
            district: Chosen.discrict || 'No District',
            community: Chosen.community || 'No Community',
            vehicle: Chosen.vehicle || 'No Vehicle',
            invoice: Chosen.invoice || 'No Invoice',
            paymentMethod: Chosen.paymentmethod || 'No Payment Method',
            others: Chosen.others || 'No Additional Information'
          }}
        />
      )}
      {Modaldeleter && (
        <Modaldelete
          name="mechanization"
          delete="mechanization"
          dispatcher={getmechanization}
          product={Chosen.name}
          chosen={Chosen}
          view={setdeleter}
          setfalser={setoffer}
          value={Modaldeleter}
        />
      )}
      {Modaledit && (
        <Modalediter
          name="Mechanization"
          product={Chosen.name}
          chosen={Chosen}
          view={setedit}
          setfalser={setoffer}
          value={Modaledit}
        />
      )}

      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <div style={{ padding: "10px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Button 
                  variant="contained" 
                  color="error" 
                  onClick={handleExpenseModalOpen}
                  fullWidth
                  startIcon={<EngineeringIcon />}
                >
                  Add Expense
                </Button>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  type="date"
                  label="Start Date"
                  value={startDate}
                  size="small"
                  fullWidth
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  type="date"
                  label="End Date"
                  value={endDate}
                  size="small"
                  fullWidth
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={typeFilter}
                    label="Type"
                    onChange={(e) => setTypeFilter(e.target.value)}
                  >
                    <MenuItem value="all">All Types</MenuItem>
                    <MenuItem value="Mechanization">Mechanization</MenuItem>
                    <MenuItem value="Expenses">Expenses</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={statusFilter}
                    label="Status"
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <MenuItem value="all">All Status</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="completed">Completed</MenuItem>
                    <MenuItem value="cancelled">Cancelled</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Agent</InputLabel>
                  <Select
                    value={agentFilter}
                    label="Agent"
                    onChange={(e) => setAgentFilter(e.target.value)}
                  >
                    <MenuItem value="all">All Agents</MenuItem>
                    {Array.isArray(agents) && agents.map((agent) => (
                      <MenuItem key={agent._id} value={agent._id}>
                        {agent.surname} {agent.othernames} {agent.lastname}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={9}>
                <div style={{ position: "relative" }}>
                  <Search style={{ position: "absolute", marginTop: "18px", marginLeft: "8px", color: "grey" }} />
                  <input
                    type="search"
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search by customer, service, or operator..."
                    style={{
                      padding: 10,
                      paddingLeft: "38px",
                      marginTop: 10,
                      width: "100%",
                      border: "solid",
                      borderRadius: "5px",
                      borderWidth: "0.5px",
                      backgroundColor: "rgba(65,105,225, 0.05)",
                      borderColor: "#2196f3"
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>

          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow
                    hover
                    onClick={(event) => showdata(event, row)}
                    role="checkbox"
                    tabIndex={-1}
                    key={row._id}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell padding="normal">
                      {(rowsPerPage*page)+index+1}
                    </TableCell>
                    <TableCell
                      id={labelId}
                      scope="row"
                    >
                      {farmer.find(item => item._id === row.customer)?.farmername || row.customer}
                    </TableCell>
                    <TableCell align="right">
                      <Chip
                        label={row.type || 'No Type'}
                        color={row.type === 'Expenses' ? 'error' : 'primary'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="right">
                      {getAgentName(row.agent)}
                    </TableCell>
                    <TableCell align="right">{row.purchase?.[0]?.product || 'No Product'}</TableCell>
                    <TableCell align="right">{row.date || 'No Date'}</TableCell>
                    <TableCell align="right">
                      {row.purchase?.[0] ? 
                        (parseFloat(row.purchase[0].qty || 0) * parseFloat(row.purchase[0].unitp || 0)).toFixed(2) 
                        : '0.00'}
                    </TableCell>
                    <TableCell align="right">
                      <Chip
                        label={row.status || 'Pending'}
                        color={
                          row.status === 'completed' ? 'success' :
                          row.status === 'cancelled' ? 'error' : 'warning'
                        }
                        size="small"
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 30]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* Expense Modal */}
      <Dialog fullWidth minWidth="sm" onClose={handleExpenseModalClose} open={expenseModalOpen}>
        <DialogTitle>
          Add Expenses
          <IconButton onClick={handleExpenseModalClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="type"
              required
              label="Type"
              type="text"
              style={{ width: "98%" }}
              autoComplete="current-text"
            />
            <TextField
              id="amount"
              required
              label="Amount"
              type="number"
              style={{ width: "98%" }}
              autoComplete="current-text"
              InputProps={{
                startAdornment: <InputAdornment position="start">GHC </InputAdornment>,
              }}
            />
            <TextField
              id="quantity"
              required
              label="Quantity"
              type="number"
              style={{ width: "98%" }}
              autoComplete="current-text"
            />
            <TextField
              id="unit"
              required
              label="Quantity Unit"
              type="text"
              style={{ width: "98%" }}
              autoComplete="current-text"
            />
            <TextField
              id="date"
              required
              label="Date"
              type="date"
              style={{ width: "98%", marginTop: "15px" }}
              autoComplete="current-text"
              defaultValue={new Date().toISOString().split('T')[0]}
            />
            <TextField
              id="location"
              required
              label="Location"
              type="text"
              style={{ width: "98%", marginTop: "15px" }}
              autoComplete="current-text"
            />
            <TextField
              id="driver"
              required
              label="Driver's Name"
              type="text"
              style={{ width: "98%", marginTop: "15px" }}
              autoComplete="current-text"
            />
            <TextField
              id="tractor"
              required
              label="Tractor Number"
              type="text"
              style={{ width: "98%", marginTop: "15px" }}
              autoComplete="current-text"
            />
            <TextField
              id="description"
              required
              label="Description"
              type="text"
              style={{ width: "98%", marginTop: "15px" }}
              autoComplete="current-text"
            />
            <FormControl style={{ width: "98%", marginTop: "15px", marginLeft: "8px" }}>
              <InputLabel id="demo-simple-select-label">Mode Of Payment</InputLabel>
              <Select
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={payment}
                label="Mode Of Payment"
                onChange={(e) => setPayment(e.target.value)}
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Momo">Momo</MenuItem>
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Cheque">Cheque</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="transaction"
              required
              label="Transaction Id / Cheque Number"
              type="text"
              style={{ width: "98%", marginTop: "15px" }}
              autoComplete="current-text"
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: "center", width: "100%" }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button
                variant="outlined"
                startIcon={<EngineeringIcon />}
                size="large"
                onClick={addExpense}
              >
                Submit Expenses
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={6000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </Box>
  );
} 